export const textFieldStyle: Record<string, object> = {
  '& .MuiInputBase-input': {
    paddingRight: '56px',
  },
};

export const inputAdornmentStyle: Record<string, string> = {
  position: 'absolute', 
  right: '20px', 
  margin: '0px',
}